import { AbortedError } from 'src/common/api/extended-emerald-error';
// import { setHomePageTendering } from 'src/home-page/components/home-page-tendering';
import { showCashbackAmountPage, ICashbackAmountProps } from '../components/cashback-amount-view';
import { getValueAsNumber } from 'src/common/helpers/number-helper';

export const handleCashbackAmount = async (amountDue: number): Promise<number> => {
  return new Promise<number>((resolve, reject) => {
    const onSubmit = (cashbackAmount: string): void => {
      if (cashbackAmount) {
        resolve(getValueAsNumber(cashbackAmount));
      }
    };

    const onCancel = (): void => reject(new AbortedError());

    const cashbackAmountProps: ICashbackAmountProps = {
      onSubmit,
      onCancel,
      amountDue,
    };

    showCashbackAmountPage(cashbackAmountProps);
  });
};
